import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import "moment-timezone";
import { Comment } from "../../interfaces/comment.interface";
import { CommentsService } from "../../services/comments.service";
import { CommentDialogueComponent } from "../comments-dialogue/comments-dialogue.component";

// This is an interface that is used by the modal to model the data that gets passed in.
export interface DialogData {
  title: string;
  objectId: number;
  itemId: number;
  commentData: CommentResponse[];
}

// This is the interface for the comment response that is returned by the backend
export interface CommentResponse {
  firstName: string;
  lastName: string;
  canDelete: boolean;
  comment: Comment;
  children: CommentResponse[];
  freshness?: string;
}

@Component({
  selector: "app-comments-button",
  templateUrl: "./comments.component.html",
  styleUrls: ["./comments.component.scss"],
  providers: [CommentsService],
})
export class CommentsComponent implements OnInit {
  @Input()
  set objectId(input) {
    this._objectId = input;
  }

  @Input()
  set itemId(input) {
    this._itemId = input;
  }

  @Input()
  set title(input) {
    this._title = input;
  }

  // This is the string for the notification bubble on the modal button
  notifications = "";

  // These are the variables for the data that gets passed in
  _title = "";
  _objectId;
  _itemId;

  // This is the map of comment responses that gets retrieved on init.
  commentResponseMap;

  constructor(
    private commentsService: CommentsService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.commentsService
      .getMap(this._objectId, this._itemId)
      .subscribe((resp) => {
        this.commentResponseMap = resp;

        // Setting the unread count for the modal button
        this.setUnreadCount();
      });
  }

  openDialog() {
    // Setting the last accessed time for the particular object/item combination
    this.commentsService.setLastAccessed(this._objectId, this._itemId);

    // Setting the undread count for the modal button
    this.setUnreadCount();

    // Setting the reference to the material dialogue and passing in the proper data
    this.dialog.open(CommentDialogueComponent, {
      disableClose: true,
      data: {
        title: this._title,
        objectId: this._objectId,
        itemId: this._itemId,
        commentData: this.commentResponseMap,
      },
      width: "50%",
    });
  }

  setUnreadCount() {
    // This gets the unread count from the commentService for display in the modal button

    const unreadCount = this.commentsService.getItemCount(
      this.commentResponseMap,
      this.commentsService.getLastAccessed(this.objectId, this.itemId),
    );

    // Caps the notification text to 5+ to prevent text clipping
    if (unreadCount > 5) {
      this.notifications = "5+";
    } else {
      this.notifications = unreadCount.toString();
    }
  }
}
